import { Text } from "@zapier/design-system";
import styles from "./InstructionsDisplay.module.css";

export interface InstructionsDisplayProps {
  /**
   * Plain text content of the instructions
   */
  content: string;
}

/**
 * InstructionsDisplay component shows the instructions section of an agent
 */
export function InstructionsDisplay({ content }: InstructionsDisplayProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text type="Body3" color="GrayWarm9">
          Instructions:
        </Text>
      </div>
      <div className={styles.content}>
        <Text type="Body1Multiline" color="GrayWarm9">
          {content}
        </Text>
      </div>
    </div>
  );
}
